'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('sgInlineEditCtrl', sgInlineEditCtrl);

  sgInlineEditCtrl.$inject = ['$scope', '$timeout', '$element', '$document',
    'errorMessageService', 'EditorConfig', '$attrs', '$sce', 'sg2ModalService', '$injector'];

  function sgInlineEditCtrl($scope, $timeout, $element, $document,
    errorMessageService, EditorConfig, $attrs, $sce, sg2ModalService, $injector) {

    const vm = this;

    vm.editmode = false;
    vm.tinymceReady = false;

    const input = {
      string: {
        option: 1,
        type: 'text'
      },
      number: {
        option: 1,
        type: 'number'
      },
      select: {
        option: 2
      },
      longstring: {
        option: 3,
        type: 'longstring'
      }
    };

    const getInputType = () => {
      // The element component might differ. In that case we need to manually set the inputType
      if (!vm.inputType) {
        return input[vm.element.inputType.toLowerCase().replace(' ', '')];
      }
      return input[vm.inputType.toLowerCase().replace(' ', '')];
    };

    const getOriginalValue = () => {
      const value = vm.element[vm.key];

      if (vm.input.type === 'number' && value === null) {
        return 0;
      }

      return value;
    };

    vm.$onInit = () => {
      vm.input = getInputType();
      vm.originalValue = getOriginalValue();

      vm.value = vm.element[vm.key];
      $scope.value = vm.value;

      setTimeout(() => {
        $scope.sg2AuthService = $injector.get('sg2AuthService');
      }, 100);

      vm.tinyMceOptions = EditorConfig({
        contentLanguage: vm.language || 'nl',
        inline: true,
        readonly: !vm.canWrite
      });

      vm.tinyMceOptions.onInit = function (editor) {
        vm.tinymceReady = true;
        $timeout(function () {
          editor.focus();
        });
      };

      if (vm.input && vm.input.type === 'number') {
        vm.value = Number(vm.value);
        vm.step = vm.float ? (1 / Math.pow(10, vm.float - 1)) : 1;
      } else if (vm.input && vm.input.type === 'longstring') {

        vm.display = $sce.trustAsHtml(String(vm.value));
      }
    };

    vm.startEditing = () => {
      if (!vm.canWrite) {
        return;
      }

      vm.isEditing = true;

      // Add activeEditing class on the parent element
      $element[0].parentNode.classList.add('sg-inline-edit-parent');

      $timeout(() => {
        $element[0].querySelector('.sg-inline-edit-input').focus();
        $document.on('keydown', vm.escapeHandler);
      });
    };

    vm.valueToString = () => {
      if (!vm.value) {
        vm.value = "";
      }
      let value = vm.input.type === 'number' ? vm.value.toString().replace('.', ',') : vm.value;

      if (vm.input.type === 'number') {
        if (value.indexOf(',') === -1 && vm.float) {
          value += ',';
        }

        const decimalLength = (value.split(',')[1] || '').length;

        for (let i = decimalLength; i < vm.float; i++) {
          value += '0';
        }
      }

      return value;
    };

    vm.submit = (ev: any = {}) => {
      // we do not want submit to fire when clicking a tinyMce panel (for example a menu/toolbar item)
      // we do want to fire when we switch between editors, thus sg-inline-start-check
      if (ev.relatedTarget && !ev.relatedTarget.className.includes('sg-inline-edit-start') &&
        (ev.relatedTarget.className.includes('mce') || ev.relatedTarget.id.includes('mce'))) {
        return;
      }

      // Only submit when there's a new value. If value undefined, the value is invalid
      if (vm.value === vm.originalValue || angular.isUndefined(vm.value)) {
        vm.reset();
        return;
      }

      if (vm.input.type === 'number') {
        vm.value = vm.value === null
          ? null
          : Number.parseFloat(vm.value.toFixed(vm.float || 2));
      }

      $document.off('keydown', vm.escapeHandler);
      if (vm.originalValue !== vm.value) {
        vm.onUpdate({element: vm.element, value: vm.value, key: vm.key}); // .then(vm.blur, vm.reset);
        vm.originalValue = getOriginalValue();
      }
      vm.blur(ev);

      // Notify parent controller of change. Without timeout, the spinner would often
      // stay (forever) after an edit. Dont know why, but this seems to solve it.
      setTimeout(() => {
        $scope.$emit('element:update:inline', vm.element);
      }, 250);
    };

    vm.escapeHandler = (e) => {
      switch (e.key) {
        case 27:
        case 'Escape':
          vm.reset();
          break;
      }
    };

    // Enable edit mode from parent controller
    vm.$onChanges = (change) => {
      if (change.element) {
        vm.$onInit();
      }
      if (change.enableEditMode && change.enableEditMode.currentValue === true) {
        vm.editmode = true;
      }
    };

    vm.blur = (ev) => {
      if (vm.inputForm && !vm.inputForm.value.$valid) {
        errorMessageService.showError('invalidvalue');
      }

      $scope.$applyAsync(() => {
        vm.isEditing = false;
      });
      $document.off('keydown', vm.escapeHandler);

      evalAttr('ngBlur', {$event: ev});
    };

    vm.focus = ($event) => {
      evalAttr('ngFocus', {$event: $event});
    }

    vm.reset = () => {
      vm.value = vm.originalValue;
      vm.blur();

      // remove active class
      $element[0].parentNode.classList.remove('sg-inline-edit-parent');
    };

    vm.$onDestroy = () => {
      $document.off('keydown', vm.escapeHandler);
    };

    /**
     * Load the tiny-mce editor
     */
    vm.enableEdit = () => {
      vm.editmode = true;
    };

    /**
     * Load TinyMce in modal.
     */
    vm.openModal = (): void => {
      if ($scope.sg2AuthService.canUpdate('element')) {
        const modal = sg2ModalService.openTinymce(vm.element);
        modal.afterClosed().subscribe((elementValue: ProjectElement['value']) => {
          if (elementValue) {
            vm.value = elementValue;
            vm.submit();
          }
        });
      }
    };

    /**
     * Evaluates an attribute expression against the parent scope.
     * @param {String} attr Name of the attribute to be evaluated.
     * @param {Object?} locals Properties to be injected into the evaluation context.
     */
    function evalAttr(attr, locals) {
      if ($attrs[attr]) {
        $scope.$parent.$eval($attrs[attr], locals || {});
      }
    }
  }

})();
